import { render, staticRenderFns } from "./ViolationTicketTip.vue?vue&type=template&id=4578cfbd&scoped=true"
import script from "./ViolationTicketTip.vue?vue&type=script&lang=js"
export * from "./ViolationTicketTip.vue?vue&type=script&lang=js"
import style0 from "./ViolationTicketTip.vue?vue&type=style&index=0&id=4578cfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578cfbd",
  null
  
)

export default component.exports